import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33405332"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-document-header" }
const _hoisted_2 = {
  class: "new-document-content",
  ref: "content"
}
const _hoisted_3 = {
  key: 0,
  class: "content-form"
}
const _hoisted_4 = { class: "envelope" }
const _hoisted_5 = { class: "envelope-title" }
const _hoisted_6 = { class: "envelope-cofre" }
const _hoisted_7 = { class: "envelope-actions" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "envelope-action-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Destinatários")
], -1))
const _hoisted_9 = { class: "envelope-action-type" }
const _hoisted_10 = { style: {"margin-right":"5px"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Incluir-me como signatário")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Assinar conforme ordem abaixo")
const _hoisted_13 = { class: "recipients" }
const _hoisted_14 = { id: "scroller" }
const _hoisted_15 = { class: "box-fields" }
const _hoisted_16 = {
  key: 0,
  class: "box-field-title"
}
const _hoisted_17 = {
  class: "box-field-dragger",
  style: {"cursor":"ns-resize"}
}
const _hoisted_18 = { class: "field" }
const _hoisted_19 = { class: "field-name" }
const _hoisted_20 = { class: "field-channels" }
const _hoisted_21 = {
  key: 0,
  class: "channel-email"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode("E-mail")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Whatsapp")
const _hoisted_24 = {
  key: 1,
  class: "channel-phone"
}
const _hoisted_25 = ["onUpdate:modelValue", "onChange"]
const _hoisted_26 = ["value", "selected"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("E-mail")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Whatsapp")
const _hoisted_30 = { class: "field-docs-and-paper" }
const _hoisted_31 = { class: "f-docs" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("CPF")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("RG")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("OUTRO")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("CPF")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("RG")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("OUTRO")
const _hoisted_38 = { class: "f-papers" }
const _hoisted_39 = {
  key: 0,
  class: "paper-title"
}
const _hoisted_40 = {
  key: 0,
  class: "field-info-docs"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "msg" }, "Este é o número do documento que o destinatário deverá informar no ato da assinatura.", -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "field-actions" }
const _hoisted_44 = { class: "action-schedule" }
const _hoisted_45 = {
  key: 0,
  style: {"margin-right":"5px"}
}
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Salvar nos Contatos")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Exigir Foto")
const _hoisted_48 = { class: "action-remove" }
const _hoisted_49 = ["disabled", "onClick"]
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Excluir ")
const _hoisted_51 = { class: "field field-expand" }
const _hoisted_52 = { class: "field-name" }
const _hoisted_53 = { class: "field-channels" }
const _hoisted_54 = {
  key: 0,
  class: "channel-email"
}
const _hoisted_55 = /*#__PURE__*/_createTextVNode("E-mail")
const _hoisted_56 = /*#__PURE__*/_createTextVNode("Whatsapp")
const _hoisted_57 = {
  key: 1,
  class: "channel-phone"
}
const _hoisted_58 = ["onUpdate:modelValue", "onChange"]
const _hoisted_59 = ["value", "selected"]
const _hoisted_60 = { key: 0 }
const _hoisted_61 = /*#__PURE__*/_createTextVNode("E-mail")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("Whatsapp")
const _hoisted_63 = { class: "field-docs-and-paper" }
const _hoisted_64 = { class: "f-docs" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode("CPF")
const _hoisted_66 = /*#__PURE__*/_createTextVNode("RG")
const _hoisted_67 = /*#__PURE__*/_createTextVNode("OUTRO")
const _hoisted_68 = /*#__PURE__*/_createTextVNode("CPF")
const _hoisted_69 = /*#__PURE__*/_createTextVNode("RG")
const _hoisted_70 = /*#__PURE__*/_createTextVNode("OUTRO")
const _hoisted_71 = { class: "f-papers" }
const _hoisted_72 = {
  key: 0,
  class: "paper-title"
}
const _hoisted_73 = {
  key: 0,
  class: "field-info-docs"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "msg" }, "Este é o número do documento que o destinatário deverá informar no ato da assinatura.", -1))
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { class: "field-actions" }
const _hoisted_77 = { class: "action-schedule" }
const _hoisted_78 = {
  key: 0,
  style: {"margin-right":"5px"}
}
const _hoisted_79 = /*#__PURE__*/_createTextVNode("Salvar nos Contatos")
const _hoisted_80 = /*#__PURE__*/_createTextVNode("Exigir Foto")
const _hoisted_81 = { class: "action-remove" }
const _hoisted_82 = ["disabled", "onClick"]
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" Excluir ")
const _hoisted_84 = { class: "actions" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode("Adicionar Destinatário ")
const _hoisted_86 = /*#__PURE__*/_createTextVNode("Lista de Contatos ")
const _hoisted_87 = {
  key: 1,
  class: "content-viewer"
}
const _hoisted_88 = {
  key: 0,
  class: "isdata"
}
const _hoisted_89 = {
  key: 0,
  class: "view-tabs"
}
const _hoisted_90 = { class: "order-file" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" Alterar ordem dos documentos ")
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "order-file-title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Ordernar Documentos"),
  /*#__PURE__*/_createElementVNode("p", null, "Ajuste a ordem dos documentos no envelope")
], -1))
const _hoisted_93 = { id: "scrollerFiles" }
const _hoisted_94 = { class: "box-file" }
const _hoisted_95 = {
  class: "file-dragger",
  style: {"cursor":"ns-resize"}
}
const _hoisted_96 = { style: {"font-size":"12px","margin-right":"1px"} }
const _hoisted_97 = /*#__PURE__*/_createTextVNode()
const _hoisted_98 = { class: "file-title" }
const _hoisted_99 = { style: {"padding":"0 5px","font-size":"14px"} }
const _hoisted_100 = ["onClick"]
const _hoisted_101 = { class: "tab" }
const _hoisted_102 = { class: "list-file" }
const _hoisted_103 = { class: "file-name" }
const _hoisted_104 = { class: "file-name-ic" }
const _hoisted_105 = ["onClick"]
const _hoisted_106 = ["src"]
const _hoisted_107 = {
  key: 1,
  class: "view-frame"
}
const _hoisted_108 = { class: "list-file" }
const _hoisted_109 = { class: "file-name" }
const _hoisted_110 = { class: "file-name-ic" }
const _hoisted_111 = ["src"]
const _hoisted_112 = /*#__PURE__*/_createTextVNode(" Clique para fazer upload de mais arquivos ")
const _hoisted_113 = {
  key: 1,
  class: "nodata"
}
const _hoisted_114 = { class: "ant-upload-drag-icon" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, " Clique ou arraste um arquivo para fazer upload ", -1))
const _hoisted_116 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_117 = /*#__PURE__*/_createTextVNode(" Enviar Para Assinatura ")
const _hoisted_118 = { class: "warning-modal-strong-content" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", { class: "warning-title-strong" }, "Atenção Importante!"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" O serviço de notificação por "),
  /*#__PURE__*/_createElementVNode("b", null, "WhatsApp"),
  /*#__PURE__*/_createTextVNode(" está instável."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Por enquanto, utilize o envio por "),
  /*#__PURE__*/_createElementVNode("b", null, "E-mail"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_120 = { style: {"text-align":"right","margin-top":"16px"} }
const _hoisted_121 = /*#__PURE__*/_createTextVNode("Entendi")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileOutlined = _resolveComponent("FileOutlined")!
  const _component_BarsOutlined = _resolveComponent("BarsOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_FolderSelectView = _resolveComponent("FolderSelectView")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_HolderOutlined = _resolveComponent("HolderOutlined")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_ContactsOutlined = _resolveComponent("ContactsOutlined")!
  const _component_Schedules = _resolveComponent("Schedules")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_OrderedListOutlined = _resolveComponent("OrderedListOutlined")!
  const _component_PaperClipOutlined = _resolveComponent("PaperClipOutlined")!
  const _component_FileTextOutlined = _resolveComponent("FileTextOutlined")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_UploadOutlined = _resolveComponent("UploadOutlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_InboxOutlined = _resolveComponent("InboxOutlined")!
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_ExclamationCircleOutlined = _resolveComponent("ExclamationCircleOutlined")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      (_ctx.isMobile)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "primary",
            shape: "circle",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showViewer())),
            class: "btn-show-viewer"
          }, {
            icon: _withCtx(() => [
              (!_ctx.isViewer)
                ? (_openBlock(), _createBlock(_component_FileOutlined, { key: 0 }))
                : _createCommentVNode("", true),
              (_ctx.isViewer)
                ? (_openBlock(), _createBlock(_component_BarsOutlined, { key: 1 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_2, [
      (_ctx.isForm)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createVNode(_component_a_form, {
              ref: "formRef",
              model: _ctx.formEnvelope,
              rules: _ctx.rules
            }, {
              default: _withCtx(() => [
                _createElementVNode("section", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_a_input, {
                      value: _ctx.formEnvelope.title,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formEnvelope.title) = $event)),
                      placeholder: "Título do Envelope"
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_FolderSelectView, {
                      onHandleChangeCofre: _ctx.handleChangeCofre,
                      selected: _ctx.cofreSelected
                    }, null, 8, ["onHandleChangeCofre", "selected"])
                  ])
                ]),
                _createElementVNode("section", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, [
                      (!_ctx.inactiveIWantToSign)
                        ? (_openBlock(), _createBlock(_component_a_checkbox, {
                            key: 0,
                            checked: _ctx.isIWantToSign,
                            "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isIWantToSign) = $event)),
                            onChange: _ctx.changeIWantToSign
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }, 8, ["checked", "onChange"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", null, [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.isOrderChecked,
                        "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isOrderChecked) = $event))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ])
                  ])
                ]),
                _createElementVNode("section", _hoisted_13, [
                  _createElementVNode("section", _hoisted_14, [
                    (_ctx.isOrderChecked)
                      ? (_openBlock(), _createBlock(_component_draggable, {
                          key: 0,
                          list: _ctx.formEnvelope.requests,
                          onChange: _ctx.dragDropInRecipients
                        }, {
                          item: _withCtx(({ element }) => [
                            _createElementVNode("section", _hoisted_15, [
                              (element.isPaperSign)
                                ? (_openBlock(), _createElementBlock("section", _hoisted_16, _toDisplayString(element.Order) + "º", 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("section", _hoisted_17, [
                                _createVNode(_component_HolderOutlined)
                              ]),
                              _createElementVNode("section", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_a_input, {
                                    value: element.PartName,
                                    "onUpdate:value": ($event: any) => ((element.PartName) = $event),
                                    placeholder: "Nome completo conforme o documento",
                                    disabled: element.iWantToSign
                                  }, null, 8, ["value", "onUpdate:value", "disabled"])
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  (!element.isWhatsapp)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _createVNode(_component_a_input, {
                                          value: element.Email,
                                          "onUpdate:value": ($event: any) => ((element.Email) = $event),
                                          placeholder: "Digite um e-mail válido",
                                          disabled: element.iWantToSign,
                                          class: "input-email"
                                        }, {
                                          addonAfter: _withCtx(() => [
                                            _createVNode(_component_a_select, {
                                              value: element.isWhatsapp,
                                              "onUpdate:value": ($event: any) => ((element.isWhatsapp) = $event),
                                              onChange: ($event: any) => (_ctx.changeTypeChannel(element)),
                                              class: "change-channel",
                                              disabled: element.iWantToSign
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_select_option, { value: false }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_22
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_select_option, { value: true }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_23
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["value", "onUpdate:value", "onChange", "disabled"])
                                          ]),
                                          _: 2
                                        }, 1032, ["value", "onUpdate:value", "disabled"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (element.isWhatsapp && !element.iWantToSign)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["flag", element.PhoneFlag])
                                        }, null, 2),
                                        (element.isWhatsapp)
                                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                              key: 0,
                                              class: "select-countries",
                                              "onUpdate:modelValue": ($event: any) => ((element.PhoneCode) = $event),
                                              onChange: ($event: any) => (_ctx.changeCountryWhatsRecipients(element))
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countriesWhatsapp, (country) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  value: country.ddi,
                                                  key: country.sigla,
                                                  selected: country.sigla == 'BR'
                                                }, _toDisplayString(country.name), 9, _hoisted_26))
                                              }), 128))
                                            ], 40, _hoisted_25)), [
                                              [_vModelSelect, element.PhoneCode]
                                            ])
                                          : _createCommentVNode("", true),
                                        (element.isWhatsapp)
                                          ? _withDirectives((_openBlock(), _createBlock(_component_a_input, {
                                              key: 1,
                                              value: element.Phone,
                                              "onUpdate:value": ($event: any) => ((element.Phone) = $event),
                                              class: "input-phone"
                                            }, {
                                              addonBefore: _withCtx(() => [
                                                (element.PhoneCode != '')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(element.PhoneCode), 1))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              addonAfter: _withCtx(() => [
                                                _createVNode(_component_a_select, {
                                                  value: element.isWhatsapp,
                                                  "onUpdate:value": ($event: any) => ((element.isWhatsapp) = $event),
                                                  onChange: ($event: any) => (_ctx.changeTypeChannel(element)),
                                                  class: "change-channel"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_select_option, { value: false }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_28
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_a_select_option, { value: true }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_29
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["value", "onUpdate:value", "onChange"])
                                              ]),
                                              _: 2
                                            }, 1032, ["value", "onUpdate:value"])), [
                                              [_directive_maska, element.PhoneMask]
                                            ])
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    (element.isDocCPF)
                                      ? _withDirectives((_openBlock(), _createBlock(_component_a_input, {
                                          key: 0,
                                          value: element.Document,
                                          "onUpdate:value": ($event: any) => ((element.Document) = $event),
                                          placeholder: "Preencha o número do documento",
                                          class: "input-doc",
                                          onChange: ($event: any) => (_ctx.validateCPF(element.Document, element.isDocCPF, true))
                                        }, {
                                          addonAfter: _withCtx(() => [
                                            _createVNode(_component_a_select, {
                                              value: element.DocumentType,
                                              "onUpdate:value": ($event: any) => ((element.DocumentType) = $event),
                                              onChange: ($event: any) => (_ctx.changeTypeDoc(element)),
                                              class: "change-doc"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_select_option, { value: "CPF" }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_32
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_select_option, { value: "RG" }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_33
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_select_option, { value: "OTHER" }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_34
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["value", "onUpdate:value", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1032, ["value", "onUpdate:value", "onChange"])), [
                                          [_directive_maska, element.docMask]
                                        ])
                                      : _createCommentVNode("", true),
                                    (element.isDocRG || element.isDocOther)
                                      ? (_openBlock(), _createBlock(_component_a_input, {
                                          key: 1,
                                          value: element.Document,
                                          "onUpdate:value": ($event: any) => ((element.Document) = $event),
                                          placeholder: "Preencha o número do documento",
                                          class: "input-doc"
                                        }, {
                                          addonAfter: _withCtx(() => [
                                            _createVNode(_component_a_select, {
                                              value: element.DocumentType,
                                              "onUpdate:value": ($event: any) => ((element.DocumentType) = $event),
                                              onChange: ($event: any) => (_ctx.changeTypeDoc(element)),
                                              class: "change-doc"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_select_option, { value: "CPF" }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_35
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_select_option, { value: "RG" }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_36
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_select_option, { value: "OTHER" }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_37
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["value", "onUpdate:value", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1032, ["value", "onUpdate:value"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_38, [
                                    (!element.iWantToSign)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Papel:"))
                                      : _createCommentVNode("", true),
                                    (!element.iWantToSign)
                                      ? (_openBlock(), _createBlock(_component_a_select, {
                                          key: 1,
                                          value: element.PaperSignatureId,
                                          "onUpdate:value": ($event: any) => ((element.PaperSignatureId) = $event),
                                          onChange: ($event: any) => (_ctx.changePaper(element)),
                                          class: "paper-select"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.papers, (paper) => {
                                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                                key: paper.id,
                                                value: paper.id
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass({ 'news' : paper.id === 10})
                                                  }, [
                                                    (paper.toSign)
                                                      ? (_openBlock(), _createBlock(_component_EditOutlined, { key: 0 }))
                                                      : _createCommentVNode("", true),
                                                    (!paper.toSign)
                                                      ? (_openBlock(), _createBlock(_component_EyeOutlined, { key: 1 }))
                                                      : _createCommentVNode("", true),
                                                    _createTextVNode(" " + _toDisplayString(paper.name), 1)
                                                  ], 2),
                                                  (paper.id === 20)
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        key: 0,
                                                        class: _normalizeClass({ 'news-info' : paper.id === 20})
                                                      }, " NOVO ", 2))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1032, ["value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["value", "onUpdate:value", "onChange"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (!element.iWantToSign)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("div", _hoisted_44, [
                                    (element.isSaveShared && !element.fromSchedule && !element.iWantToSign)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                                          _createVNode(_component_a_checkbox, {
                                            checked: element.isScheduleRecipient,
                                            "onUpdate:checked": ($event: any) => ((element.isScheduleRecipient) = $event)
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_46
                                            ]),
                                            _: 2
                                          }, 1032, ["checked", "onUpdate:checked"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", null, [
                                      (element.isSaveShared || element.iWantToSign)
                                        ? (_openBlock(), _createBlock(_component_a_checkbox, {
                                            key: 0,
                                            checked: element.isWithPhoto,
                                            "onUpdate:checked": ($event: any) => ((element.isWithPhoto) = $event)
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_47
                                            ]),
                                            _: 2
                                          }, 1032, ["checked", "onUpdate:checked"]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_48, [
                                    (_ctx.formEnvelope.requests.length > 1)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "btn-remove",
                                          disabled: _ctx.formEnvelope.requests.length === 1,
                                          onClick: ($event: any) => (_ctx.removeRecipients(element))
                                        }, [
                                          _hoisted_50,
                                          _createVNode(_component_DeleteOutlined)
                                        ], 8, _hoisted_49))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["list", "onChange"]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.formEnvelope.requests, (domain) => {
                          return (_openBlock(), _createElementBlock("section", {
                            key: domain.key,
                            class: "box-fields"
                          }, [
                            _createElementVNode("section", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _createVNode(_component_a_input, {
                                  value: domain.PartName,
                                  "onUpdate:value": ($event: any) => ((domain.PartName) = $event),
                                  placeholder: "Nome completo conforme o documento",
                                  disabled: domain.iWantToSign
                                }, null, 8, ["value", "onUpdate:value", "disabled"])
                              ]),
                              _createElementVNode("div", _hoisted_53, [
                                (!domain.isWhatsapp)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                      _createVNode(_component_a_input, {
                                        value: domain.Email,
                                        "onUpdate:value": ($event: any) => ((domain.Email) = $event),
                                        placeholder: "Digite um e-mail válido",
                                        disabled: domain.iWantToSign,
                                        class: "input-email"
                                      }, {
                                        addonAfter: _withCtx(() => [
                                          _createVNode(_component_a_select, {
                                            value: domain.isWhatsapp,
                                            "onUpdate:value": ($event: any) => ((domain.isWhatsapp) = $event),
                                            onChange: ($event: any) => (_ctx.changeTypeChannel(domain)),
                                            class: "change-channel",
                                            disabled: domain.iWantToSign || !_ctx.isWhatsappActive
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_select_option, { value: false }, {
                                                default: _withCtx(() => [
                                                  _hoisted_55
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_a_select_option, { value: true }, {
                                                default: _withCtx(() => [
                                                  _hoisted_56
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["value", "onUpdate:value", "onChange", "disabled"])
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "onUpdate:value", "disabled"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (domain.isWhatsapp && !domain.iWantToSign)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["flag", domain.PhoneFlag])
                                      }, null, 2),
                                      (domain.isWhatsapp)
                                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                            key: 0,
                                            class: "select-countries",
                                            "onUpdate:modelValue": ($event: any) => ((domain.PhoneCode) = $event),
                                            onChange: ($event: any) => (_ctx.changeCountryWhatsRecipients(domain))
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countriesWhatsapp, (country) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                value: country.ddi,
                                                key: country.sigla,
                                                selected: country.sigla == 'BR'
                                              }, _toDisplayString(country.name), 9, _hoisted_59))
                                            }), 128))
                                          ], 40, _hoisted_58)), [
                                            [_vModelSelect, domain.PhoneCode]
                                          ])
                                        : _createCommentVNode("", true),
                                      (domain.isWhatsapp)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_a_input, {
                                            key: 1,
                                            value: domain.Phone,
                                            "onUpdate:value": ($event: any) => ((domain.Phone) = $event),
                                            class: "input-phone"
                                          }, {
                                            addonBefore: _withCtx(() => [
                                              (domain.PhoneCode != '')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(domain.PhoneCode), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            addonAfter: _withCtx(() => [
                                              _createVNode(_component_a_select, {
                                                value: domain.isWhatsapp,
                                                "onUpdate:value": ($event: any) => ((domain.isWhatsapp) = $event),
                                                onChange: ($event: any) => (_ctx.changeTypeChannel(domain)),
                                                class: "change-channel"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_select_option, { value: false }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_61
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_a_select_option, { value: true }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_62
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 2
                                              }, 1032, ["value", "onUpdate:value", "onChange"])
                                            ]),
                                            _: 2
                                          }, 1032, ["value", "onUpdate:value"])), [
                                            [_directive_maska, domain.PhoneMask]
                                          ])
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                  (domain.isDocCPF)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_a_input, {
                                        key: 0,
                                        value: domain.Document,
                                        "onUpdate:value": ($event: any) => ((domain.Document) = $event),
                                        placeholder: "Preencha o número do documento",
                                        class: "input-doc",
                                        onChange: ($event: any) => (_ctx.validateCPF(domain.Document, domain.isDocCPF, true))
                                      }, {
                                        addonAfter: _withCtx(() => [
                                          _createVNode(_component_a_select, {
                                            value: domain.DocumentType,
                                            "onUpdate:value": ($event: any) => ((domain.DocumentType) = $event),
                                            onChange: ($event: any) => (_ctx.changeTypeDoc(domain)),
                                            class: "change-doc"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_select_option, { value: "CPF" }, {
                                                default: _withCtx(() => [
                                                  _hoisted_65
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_a_select_option, { value: "RG" }, {
                                                default: _withCtx(() => [
                                                  _hoisted_66
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_a_select_option, { value: "OTHER" }, {
                                                default: _withCtx(() => [
                                                  _hoisted_67
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["value", "onUpdate:value", "onChange"])
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "onUpdate:value", "onChange"])), [
                                        [_directive_maska, domain.docMask]
                                      ])
                                    : _createCommentVNode("", true),
                                  (domain.isDocRG || domain.isDocOther)
                                    ? (_openBlock(), _createBlock(_component_a_input, {
                                        key: 1,
                                        value: domain.Document,
                                        "onUpdate:value": ($event: any) => ((domain.Document) = $event),
                                        placeholder: "Preencha o número do documento",
                                        class: "input-doc"
                                      }, {
                                        addonAfter: _withCtx(() => [
                                          _createVNode(_component_a_select, {
                                            value: domain.DocumentType,
                                            "onUpdate:value": ($event: any) => ((domain.DocumentType) = $event),
                                            onChange: ($event: any) => (_ctx.changeTypeDoc(domain)),
                                            class: "change-doc"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_select_option, { value: "CPF" }, {
                                                default: _withCtx(() => [
                                                  _hoisted_68
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_a_select_option, { value: "RG" }, {
                                                default: _withCtx(() => [
                                                  _hoisted_69
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_a_select_option, { value: "OTHER" }, {
                                                default: _withCtx(() => [
                                                  _hoisted_70
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["value", "onUpdate:value", "onChange"])
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "onUpdate:value"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_71, [
                                  (!domain.iWantToSign)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_72, "Papel:"))
                                    : _createCommentVNode("", true),
                                  (!domain.iWantToSign)
                                    ? (_openBlock(), _createBlock(_component_a_select, {
                                        key: 1,
                                        value: domain.PaperSignatureId,
                                        "onUpdate:value": ($event: any) => ((domain.PaperSignatureId) = $event),
                                        onChange: ($event: any) => (_ctx.changePaper(domain)),
                                        class: "paper-select"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.papers, (paper) => {
                                            return (_openBlock(), _createBlock(_component_a_select_option, {
                                              key: paper.id,
                                              value: paper.id
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", {
                                                  class: _normalizeClass({ news : paper.id === 10})
                                                }, [
                                                  (paper.toSign)
                                                    ? (_openBlock(), _createBlock(_component_EditOutlined, { key: 0 }))
                                                    : _createCommentVNode("", true),
                                                  (!paper.toSign)
                                                    ? (_openBlock(), _createBlock(_component_EyeOutlined, { key: 1 }))
                                                    : _createCommentVNode("", true),
                                                  _createTextVNode(" " + _toDisplayString(paper.name), 1)
                                                ], 2),
                                                (paper.id === 20)
                                                  ? (_openBlock(), _createElementBlock("span", {
                                                      key: 0,
                                                      class: _normalizeClass({ 'news-info' : paper.id === 20})
                                                    }, " NOVO ", 2))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "onUpdate:value", "onChange"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (!domain.iWantToSign)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_73, _hoisted_75))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_76, [
                                _createElementVNode("div", _hoisted_77, [
                                  (domain.isSaveShared && !domain.fromSchedule && !domain.iWantToSign)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_78, [
                                        _createVNode(_component_a_checkbox, {
                                          checked: domain.isScheduleRecipient,
                                          "onUpdate:checked": ($event: any) => ((domain.isScheduleRecipient) = $event)
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_79
                                          ]),
                                          _: 2
                                        }, 1032, ["checked", "onUpdate:checked"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", null, [
                                    (domain.isSaveShared || domain.iWantToSign)
                                      ? (_openBlock(), _createBlock(_component_a_checkbox, {
                                          key: 0,
                                          checked: domain.isWithPhoto,
                                          "onUpdate:checked": ($event: any) => ((domain.isWithPhoto) = $event)
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_80
                                          ]),
                                          _: 2
                                        }, 1032, ["checked", "onUpdate:checked"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_81, [
                                  (_ctx.formEnvelope.requests.length > 1)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "btn-remove",
                                        disabled: _ctx.formEnvelope.requests.length === 1,
                                        onClick: ($event: any) => (_ctx.removeRecipients(domain))
                                      }, [
                                        _hoisted_83,
                                        _createVNode(_component_DeleteOutlined)
                                      ], 8, _hoisted_82))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]))
                        }), 128)),
                    _createElementVNode("section", _hoisted_84, [
                      _createVNode(_component_a_button, {
                        size: "large",
                        type: "primary",
                        onClick: _ctx.addRecipients,
                        class: "add-recipient"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_PlusOutlined)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_85
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_a_button, {
                        size: "large",
                        onClick: _ctx.showModalSchedule,
                        class: "list-contacts"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_ContactsOutlined)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_86
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_a_modal, {
                        visible: _ctx.openSchedule,
                        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.openSchedule) = $event)),
                        centered: "",
                        footer: null,
                        maskClosable: false,
                        onOk: _ctx.closeModalSchedule,
                        width: "1000px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Schedules, {
                            onIsCloseModal: _ctx.closeModalSchedule,
                            onAddToEnvelope: _ctx.addToEnvelope
                          }, null, 8, ["onIsCloseModal", "onAddToEnvelope"])
                        ]),
                        _: 1
                      }, 8, ["visible", "onOk"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isViewer)
        ? (_openBlock(), _createElementBlock("section", _hoisted_87, [
            (_ctx.fileUrl)
              ? (_openBlock(), _createElementBlock("section", _hoisted_88, [
                  (_ctx.formEnvelope.files.length > 1)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_89, [
                        _createElementVNode("section", _hoisted_90, [
                          _createVNode(_component_a_button, {
                            class: "btn-order-file",
                            onClick: _ctx.showModalOrderFiles
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_OrderedListOutlined),
                              _hoisted_91
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_a_modal, {
                            visible: _ctx.visible,
                            onOk: _ctx.confirmOrderFiles,
                            onCancel: _ctx.closeModalOrderFiles,
                            cancelText: "Cancelar",
                            okText: "Confirmar Ordenação"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_92,
                              _createElementVNode("section", _hoisted_93, [
                                _createVNode(_component_draggable, { list: _ctx.tempFiles }, {
                                  item: _withCtx(({ element }) => [
                                    _createElementVNode("div", _hoisted_94, [
                                      _createElementVNode("div", _hoisted_95, [
                                        _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.getIndexForItem(element) + 1), 1),
                                        _hoisted_97,
                                        _createVNode(_component_HolderOutlined)
                                      ]),
                                      _createElementVNode("div", _hoisted_98, [
                                        _createElementVNode("span", _hoisted_99, [
                                          _createVNode(_component_PaperClipOutlined, { rotate: "135" })
                                        ]),
                                        _createTextVNode(" " + _toDisplayString(element.files.name), 1)
                                      ]),
                                      _createElementVNode("div", {
                                        class: "file-remove",
                                        onClick: ($event: any) => (_ctx.removeItemInOrderFiles(element))
                                      }, [
                                        _createVNode(_component_DeleteOutlined)
                                      ], 8, _hoisted_100)
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["list"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["visible", "onOk", "onCancel"])
                        ]),
                        _createVNode(_component_a_tabs, {
                          activeKey: _ctx.activeTabViewer,
                          "onUpdate:activeKey": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeTabViewer) = $event)),
                          "default-active-key": "1"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formEnvelope.files.length, (i) => {
                              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                                key: `${i}`
                              }, {
                                tab: _withCtx(() => [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_FileTextOutlined),
                                    _createTextVNode(" " + _toDisplayString(i), 1)
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("section", _hoisted_101, [
                                    _createElementVNode("section", _hoisted_102, [
                                      _createElementVNode("div", _hoisted_103, [
                                        _createElementVNode("span", _hoisted_104, [
                                          _createVNode(_component_PaperClipOutlined, { rotate: "135" })
                                        ]),
                                        _createTextVNode(" " + _toDisplayString(_ctx.getFileName(i)), 1)
                                      ]),
                                      _createElementVNode("div", {
                                        class: "file-remove",
                                        onClick: ($event: any) => (_ctx.removeFileSelected(i))
                                      }, [
                                        _createVNode(_component_DeleteOutlined)
                                      ], 8, _hoisted_105)
                                    ]),
                                    _createElementVNode("iframe", {
                                      src: _ctx.fileUrlMult(i),
                                      type: "application/pdf",
                                      style: {"height":"90%","border":"0","border-radius":"4px"}
                                    }, "\n              ", 8, _hoisted_106)
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["activeKey"])
                      ]))
                    : (_openBlock(), _createElementBlock("section", _hoisted_107, [
                        _createElementVNode("section", _hoisted_108, [
                          _createElementVNode("div", _hoisted_109, [
                            _createElementVNode("span", _hoisted_110, [
                              _createVNode(_component_PaperClipOutlined, { rotate: "135" })
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.getFileName(1)), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "file-remove",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removeFileSelected()))
                          }, [
                            _createVNode(_component_DeleteOutlined)
                          ])
                        ]),
                        _createElementVNode("iframe", {
                          src: _ctx.fileUrl,
                          type: "application/pdf",
                          style: {"height":"92%","width":"100%","border":"0","border-radius":"4px"}
                        }, "\n        ", 8, _hoisted_111)
                      ])),
                  _createElementVNode("section", {
                    class: _normalizeClass(["plus-files", {'is-zoomed-plus-files': _ctx.isZoomed }])
                  }, [
                    _createVNode(_component_a_upload, {
                      accept: "application/pdf",
                      action: 
            (f) => {
              _ctx.files.push(f)
            }
          ,
                      customRequest: _ctx.customRequest,
                      "file-list": _ctx.formEnvelope.files,
                      "show-upload-list": false,
                      multiple: true,
                      onChange: _ctx.handleChange
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          disabled: _ctx.files.length >= 10
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_UploadOutlined),
                            _hoisted_112
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }, 8, ["action", "customRequest", "file-list", "onChange"])
                  ], 2)
                ]))
              : (_openBlock(), _createElementBlock("section", _hoisted_113, [
                  _createVNode(_component_a_upload_dragger, {
                    accept: "application/pdf",
                    action: 
            (f) => {
              _ctx.files.push(f)
            }
          ,
                    customRequest: _ctx.customRequest,
                    "file-list": _ctx.formEnvelope.files,
                    multiple: true,
                    onChange: _ctx.handleChangeDrag
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_114, [
                        _createVNode(_component_InboxOutlined)
                      ]),
                      _hoisted_115
                    ]),
                    _: 1
                  }, 8, ["action", "customRequest", "file-list", "onChange"])
                ]))
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("section", {
      class: _normalizeClass(["new-document-footer", {'is-zoomed-new-document': _ctx.isZoomed }])
    }, [
      _createVNode(_component_a_button, {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.back())),
        class: "btn-back"
      }, {
        default: _withCtx(() => [
          _hoisted_116
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        type: "primary",
        class: "btn-tosign",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.upload())),
        disabled: 
        (_ctx.formEnvelope.title === null || _ctx.formEnvelope.title === '') ||
        _ctx.formEnvelope.files.length === 0 ||
        _ctx.formEnvelope.requests[0].PartName === '' ||
        ( _ctx.formEnvelope.requests[0].Email === '' && _ctx.formEnvelope.requests[0].Phone === '' ) ||
        _ctx.formEnvelope.folder.folderId === null ||
        _ctx.loading
      
      }, {
        default: _withCtx(() => [
          _hoisted_117
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 2),
    _createVNode(_component_a_modal, {
      visible: _ctx.openWhatsappWarning,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.openWhatsappWarning) = $event)),
      centered: "",
      footer: null,
      "wrap-class-name": "warning-modal-strong",
      title: "Atenção"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_118, [
          _createVNode(_component_ExclamationCircleOutlined, { class: "warning-icon-strong" }),
          _hoisted_119
        ]),
        _createElementVNode("div", _hoisted_120, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.modalWhatsappOk
          }, {
            default: _withCtx(() => [
              _hoisted_121
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}